<template>
  <div>
    <b-form>
      <b-row>
        <!-- Field: Action -->
        <b-col
            cols="12"
            md="4"
        >
          <b-form-group
              label="Descrição"
              label-for="dominio_descricao"
          >
            <b-form-input
                id="dominio_descricao"
                v-model="dominioData.dominio_descricao"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Subject -->
        <b-col
            cols="12"
            md="4"
        >
          <b-form-group
              label="Servidor"
              label-for="dominio_servidor"
          >
            <b-form-input
                id="dominio_servidor"
                v-model="dominioData.dominio_servidor"
                type="text"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Descricao -->
        <b-col
            cols="12"
            md="4"
        >
          <b-form-group
              label="Caminho"
              label-for="dominio_caminho"
          >
            <b-form-input
                id="dominio_caminho"
                v-model="dominioData.dominio_caminho"
                type="text"
            />
          </b-form-group>
        </b-col>

      </b-row>
      <b-row>
        <b-col
            cols="12"
            md="4"
        >
          <b-form-group
              label="Ldpa"
              label-for="ldpa"
          >
            <b-form-input
                id="ldpa"
                v-model="dominioData.dominio_ldap"
                type="text"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
    <!-- Action Buttons -->
    <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
        @click="() => onSubmit(dominioData)"
    >
      Salvar Alterações
    </b-button>
    <b-button
        variant="outline-secondary"
        type="reset"
        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
    >
      Cancelar
    </b-button>
  </div>
</template>

<script>

import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
  BDropdownItem,
} from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import vSelect from 'vue-select';
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils';
import { ref } from '@vue/composition-api';
import store from '@/store';
import Notifier from '@/libs/Notifier';
import usePermissaoList from '@/views/app/permissao/permissao-list/usePermissaoList';

export default {
  components: {
    BDropdownItem,
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    vSelect,
  },
  props: {
    dominioData: {
      type: Object,
      required: true,
    },

  },
  setup(props) {
    const notify = new Notifier();

    const { resolveUserRoleVariant } = usePermissaoList();

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const onSubmit = (dominioData) => {
      console.log(dominioData);
      store.dispatch('app-dominio/putDominio', dominioData)
        .then(() => {
          notify.success('Dominio Alterado com sucesso');
        });
    };
    return {
      resolveUserRoleVariant,
      avatarText,
      onSubmit,

      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,

    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
